import { render } from "./SuscPagoPendientes.vue?vue&type=template&id=098ae044"
import script from "./SuscPagoPendientes.vue?vue&type=script&lang=js"
export * from "./SuscPagoPendientes.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__